export function downloadBlob(blob, filename) {
  // Create a URL for the blob
  const url = URL.createObjectURL(blob);

  // Create a temporary link to download the file
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;

  // Append to the document, click and then remove
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // Clean up by revoking the object URL
  URL.revokeObjectURL(url);
}
